import { Segmented } from "antd"
import cls from "classname"

import Images from "../../../../Images"

import "./DataSourceSwitcher.less"

const options = [
  {
    icon: <img src={Images.switcher_stripe} alt="Stripe" height={20} width={20} />,
    value: "stripe"
  },
  {
    icon: <img src={Images.switcher_shopify} alt="Shopify" width={20} height={20} />,
    value: "shopify"
  }
]

const DataSourceSwitcher = ({ dataSource, onSwitch, loading, disabled = false }) => {
  return (
    <Segmented
      options={options}
      value={dataSource}
      onChange={onSwitch}
      disabled={loading || disabled}
      className={cls("bh-data-source-switcher", { "bh-data-source-switcher--loading": loading })}
    />
  )
}

export default DataSourceSwitcher
